angular.module('TetherApp').factory('listenerExperienceService', [
    '$http',
    function($http) {

        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getList = function (listenerId) {
            let uri = '/api/v1/listeners/listener-experiences' +
                randomString(
                    16,
                    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                );
            return $http.get(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' },
                    listener_id: listenerId
                }
            )
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let create = function (data) {
            return $http.post(
                '/api/v1/listener-experience',
                data,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let update = function (data) {
            return $http.put(
                '/api/v1/listener-experience/' + data.id,
                data,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let deleteListener = function (listenerId) {
            let uri = '/api/v1/listener-experience/' + listenerId;
            return $http.delete(
                uri,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            getList: getList,
            create: create,
            update: update,
            deleteListener: deleteListener
        }
    }
]);
